import { z } from 'zod';
import { Gender } from '../enums.js';

export const updatePatientSchema = z.object({
  first_name: z.string().min(1),
  last_name: z.string().min(1),
  birth_date: z.string().min(1),
  email: z.email(),
  phone: z.string().min(1),
  gender: z.enum(Gender),
});

export const updatePatientParamsSchema = z.object({
  patient_id: z.string().min(1),
});

export type UpdatePatientParams = z.infer<typeof updatePatientParamsSchema>;

export type UpdatePatientPayload = z.infer<typeof updatePatientSchema>;
